/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { Vector3Like } from 'three';

/**
 * Type guard for Vector3Tuple
 */
export const isVector3Like = (p: any): p is Vector3Like =>
  p?.isVector3 ||
  (typeof p?.x === 'number' && typeof p?.y === 'number' && typeof p?.z === 'number');
